import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import Footer from '../layouts/footer/Footer'
import MainNavbar from '../layouts/header/MainNavbar'

const TermsOfUseContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

const TermsOfUseTitle = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
`;

const TermsOfUseSubTitle = styled.h2`
  font-size: 18px;
  margin-top: 25px;
  margin-bottom: 10px;
`;

const TermsOfUseText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 10px;
`;

const TermsOfUse = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Uslovi korišćenja | Snus Srbija</title>
        <meta
          name="description"
          content="Uslovi korišćenja veb stranice Snus Srbija - pravila kupovine, isporuke i korišćenja sajta."
        />
        <link rel="canonical" href="https://www.snussrbija.com/uslovi-koriscenja" />
      </Helmet>
      <MainNavbar />
      <TermsOfUseContainer as="main">
        <TermsOfUseTitle>{t('TermsOfUse.TITLE')}</TermsOfUseTitle>
        <TermsOfUseText>
          {t('TermsOfUse.LAST_UPDATED')} 24.8.2026.
        </TermsOfUseText>
        <TermsOfUseText>{t('TermsOfUse.INTRO')}</TermsOfUseText>

        <TermsOfUseSubTitle>{t('TermsOfUse.AGE_RESTRICTION_TITLE')}</TermsOfUseSubTitle>
        <TermsOfUseText>{t('TermsOfUse.AGE_RESTRICTION_TEXT')}</TermsOfUseText>

        <TermsOfUseSubTitle>{t('TermsOfUse.PRODUCTS_TITLE')}</TermsOfUseSubTitle>
        <TermsOfUseText>{t('TermsOfUse.PRODUCTS_TEXT')}</TermsOfUseText>

        <TermsOfUseSubTitle>{t('TermsOfUse.ORDERS_TITLE')}</TermsOfUseSubTitle>
        <TermsOfUseText>{t('TermsOfUse.ORDERS_TEXT')}</TermsOfUseText>

        <TermsOfUseSubTitle>{t('TermsOfUse.PRICES_TITLE')}</TermsOfUseSubTitle>
        <TermsOfUseText>{t('TermsOfUse.PRICES_TEXT')}</TermsOfUseText>

        <TermsOfUseSubTitle>{t('TermsOfUse.RETURNS_TITLE')}</TermsOfUseSubTitle>
        <TermsOfUseText>{t('TermsOfUse.RETURNS_TEXT')}</TermsOfUseText>

        <TermsOfUseSubTitle>{t('TermsOfUse.LIABILITY_TITLE')}</TermsOfUseSubTitle>
        <TermsOfUseText>{t('TermsOfUse.LIABILITY_TEXT')}</TermsOfUseText>

        <TermsOfUseSubTitle>{t('TermsOfUse.CHANGES_TITLE')}</TermsOfUseSubTitle>
        <TermsOfUseText>{t('TermsOfUse.CHANGES_TEXT')}</TermsOfUseText>

        <TermsOfUseSubTitle>{t('TermsOfUse.CONTACT_TITLE')}</TermsOfUseSubTitle>
        <TermsOfUseText>{t('TermsOfUse.CONTACT_TEXT')}</TermsOfUseText>
      </TermsOfUseContainer>
      <Footer />
    </>
  );
};

export default TermsOfUse;
